/*eslint no-undef: "off"*/

import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'

import { useCurrentUserStore } from '@/stores/useCurrentUserStore'

export const NOTIFICATION_USER_LIST_QUERY_KEY = ['notifications', 'user']

export async function getNotificationUserList() {
    const { dashboardAPI } = useAPI()

    const { notifications } = (await dashboardAPI('/notifications/user')) ?? {}

    return notifications ?? []
}

export function useQueryNotificationUserList({ queryKey = NOTIFICATION_USER_LIST_QUERY_KEY, options = {} } = {}) {
    const currentUser = useCurrentUserStore()
    const { featureFlags } = useAnalytics()

    return useQuery({
        queryKey,
        queryFn: () => getNotificationUserList(),
        // The endpoint is per-user, so the fetch waits for an authenticated session rather than
        // being kicked off by hand from the sign-in flow.
        enabled: computed(() => !!currentUser.id && !!featureFlags.signalWatchNotifications),
        refetchOnWindowFocus: false,
        ...options,
    })
}
